module.exports = __webpack_public_path__ + "static/media/andjce-prix-des-Humanités-règlement-2017-2018.c9bfb74a.pdf";